import { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormKeys } from '@nx-customer-apps/shared/enums';

export function calculationMethodValidator(group: AbstractControl): ValidationErrors | null {
    const radio = group.get(FormKeys.StandardMethod)?.value;
    const text = group.get(FormKeys.DefinedValue)?.value;
    const isValid = radio || typeof text === 'number';
    return !isValid ? { message: 'HEATLOAD.CALCULATION_METHOD.ERRORS.REQUIRED' } : null;
}
